import React, { useState } from 'react'
import {
  message,
  Form,
  AutoComplete,
  Input,
  Modal,
  Spin,
  Row,
  Col,
  Button,
  Table
} from 'antd'
import ds from '../../Services/DataServices'
import { useSelector, useDispatch } from 'react-redux'
import Spinner from 'reactstrap/lib/Spinner'
import CheckImage from '../../assets/images/checkimage.jpg'
import CancelImage from '../../assets/images/cancelcheck.png'
import {
  loadPaymentStatusModalShow,
  loadPaymentCloseWindow,
  loadPaymentTypesModalShow,
  loadSubPermService
} from '../../appRedux/actions/CommonData'
import { getMenu } from '../../appRedux/actions/Auth'
import { loadSalePaymentStatus } from '../../appRedux/actions/Sell'
import { PAY_PAY_MODE } from '../../constants/StoreSetting'
import { putIndexSalePaymentInProgress } from '../../appRedux/actions'
import { env } from '../../env'

const { REACT_APP_BUS_SITE_APP } = env

const columns = [
  {
    title: 'AMOUNT',
    dataIndex: 'amount',
    key: 'amount',
    render: (text, record) => {
      let currency = ''
      if (record.currency) {
        currency = record.currency == '978' ? 'EUR' : record.currency
      }
      return <strong>{text ? `${text} ${currency}` : ''}</strong>
    }
  },
  {
    title: 'DATE',
    dataIndex: 'paymentOn',
    key: 'paymentOn',
    render: (text, record) => {
      let date = ''
      if (text && text != '') {
        date = new Date(text)
        date = date.toLocaleString()
      }
      return <span>{date} </span>
    }
  },
  {
    title: 'IDENTIFIER',
    dataIndex: 'paymentIdentifier',
    key: 'paymentIdentifier',
    render: (text, record) => {
      return <span>{text} </span>
    }
  },
  {
    title: 'SESSION',
    dataIndex: 'session',
    key: 'session',
    render: (text, record) => {
      return <span>{text} </span>
    }
  }
]

const PaymentStatusModal = props => {
  const [form] = Form.useForm()
  const dispatch = useDispatch()

  const getReduxPaymentModalShow = useSelector(
    ({ commonConfigs }) => commonConfigs.showPaymentStatusModal
  )

  const getReduxPaymentStatusData = useSelector(
    ({ commonConfigs }) => commonConfigs.paymentStatusData
  )
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)

  const [getTableData, setTableData] = React.useState([])

  React.useEffect(() => {
    let mounted = true
    let array = []
    if (
      mounted &&
      getReduxPaymentStatusData &&
      getReduxPaymentStatusData.amount
    ) {
      array = array.concat(getReduxPaymentStatusData)
      setTableData(array)
      const data = getReduxPaymentStatusData
      if (data && data.mode && data.isOk && data.isPaid) {
        if (data.mode == PAY_PAY_MODE.SUBSCRIPTION) {
          dispatch(loadSubPermService(isOnline))
          dispatch(getMenu())
        }
        if (data.mode == PAY_PAY_MODE.SALE) {
          putIndexSalePaymentInProgress(
            localStorage.getItem('index_key'),
            data,
            'SellPaymentCalculator'
          )
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxPaymentStatusData])

  return (
    <Modal
      centered
      visible={getReduxPaymentModalShow}
      footer={null}
      width={getTableData.length > 0 ? 800 : 600}
      onCancel={() => {
        dispatch(loadPaymentStatusModalShow(false))
        if (window.location.href.includes('payment')) {
          dispatch(loadPaymentCloseWindow(true))
        } else {
          localStorage.setItem('statusresponse', '') // this is for the resp check on call generated screen
          dispatch(loadPaymentTypesModalShow(false))
          dispatch(loadSalePaymentStatus(false))
          if (
            getReduxPaymentStatusData &&
            getReduxPaymentStatusData.mode == `${PAY_PAY_MODE.SUBSCRIPTION}`
          ) {
            window.location.reload(true)
          } else if (
            getReduxPaymentStatusData &&
            getReduxPaymentStatusData.mode ==
              `${PAY_PAY_MODE.REGISTRATION_SUBSCRIPTION}`
          ) {
            if (getReduxPaymentStatusData.isPaid) {
              const msg = 'Kindly check your email inbox/spam and try login'
              message.info(msg, 4)
              setTimeout(() => {
                window.location.assign(`${REACT_APP_BUS_SITE_APP}`)
              }, 4000)
            } else {
              window.location.assign(`${REACT_APP_BUS_SITE_APP}/billing/plan`)
            }
          }
        }
      }}
      cancelButtonProps={{
        className: 'dk-btn-cancel'
      }}
    >
      <Spin tip={'Loading'} spinning={false} size='large'>
        <div>
          {getReduxPaymentStatusData && getReduxPaymentStatusData.isOk ? (
            <>
              {getReduxPaymentStatusData.isPaid ? (
                <>
                  <Row style={{ marginTop: -24 }} justify='center'>
                    <Col>
                      <img src={CheckImage} alt='' />
                    </Col>
                  </Row>

                  <Row
                    style={{ marginTop: -18, marginBottom: 18 }}
                    justify='center'
                  >
                    <Col>
                      <h4>
                        <strong>{getReduxPaymentStatusData.message}</strong>
                      </h4>
                    </Col>
                  </Row>

                  {getTableData && getTableData.length > 0 && (
                    <Table
                      className='gx-table-responsive'
                      columns={columns}
                      dataSource={getTableData}
                      footer={null}
                    />
                  )}
                </>
              ) : (
                <>
                  <Row style={{ marginTop: -24 }} justify='center'>
                    <Col>
                      <img src={CancelImage} alt='' />
                    </Col>
                  </Row>

                  <Row
                    style={{ marginTop: -18, marginBottom: 18 }}
                    justify='center'
                  >
                    <Col>
                      <h4>
                        <strong>{getReduxPaymentStatusData.message}</strong>
                      </h4>
                    </Col>
                  </Row>

                  {getTableData && getTableData.length > 0 && (
                    <Table
                      className='gx-table-responsive'
                      columns={columns}
                      dataSource={getTableData}
                      footer={null}
                    />
                  )}
                </>
              )}
            </>
          ) : (
            <>
              <Row style={{ marginTop: -24 }} justify='center'>
                <Col>
                  <img src={CancelImage} alt='' />
                </Col>
              </Row>

              <Row
                style={{ marginTop: -18, marginBottom: 18 }}
                justify='center'
              >
                <Col>
                  <h4>
                    <strong>{getReduxPaymentStatusData.message}</strong>
                  </h4>
                </Col>
              </Row>

              {/* {getTableData && getTableData.length > 0 && (
                <Table
                  className="gx-table-responsive"
                  columns={columns}
                  dataSource={getTableData}
                  footer={null}
                />
              )} */}
            </>
          )}
        </div>
      </Spin>
    </Modal>
  )
}

export default PaymentStatusModal
